import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Router from 'vue-router'
import App from './App.vue'
import store from './store'
import 'es6-object-assign/auto'
import '@/util/icons'
import { createI18n } from '@/util/lang'
import { createRouter } from '@/router'
import VueSimpleAlert from "vue-simple-alert";
import VueGtag from "vue-gtag";
//import { getGTAG } from '@/util/api'

Vue.use(VueGtag, {
  config: { id: 'UA-36718000-18' }
});

// Import main styles (including bulma) for use in all components.
// Note that variables and mixins will not be imported, so any
// components that require them should also use:
//   @import '@/sass/app.scss';
//import '@/sass/app.scss'

Vue.config.productionTip = false

// Attach the i18n plugin before the router so that the router can use it
Vue.use(VueI18n)
const i18n = createI18n()

// Attach the confirm dialog plugin
Vue.use(VueSimpleAlert); 

Vue.use(Router)
const router = createRouter()

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
